import { GOOGLE_CLIENT_ID, META_APP_ID } from '@config/config';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { ConfigProvider } from 'antd';
import 'react-toastify/dist/ReactToastify.css';
import { AuthProvider } from './contexts/AuthContext';
import { FederatedSignInProviderFallback } from '@contexts/FederatedSignInContext';
import { AuthProvider as OidcAuthProvider } from 'react-oidc-context';

import FacebookSDKLoader from '@components/FacebookSDKLoader';
import HubspotScript from '@components/HubspotScript';
import { APP_ENV } from '@config/config';
import { cognitoOidcConfig } from '@config/cognitoOidc';
import { AntTheme } from '@constants/theme';
import { BrandingProvider } from '@contexts/BrandingContext';
import { ToastContainer } from 'react-toastify';
import { useEffect } from 'react';
import AppRoutes from './AppRoutes';
import AppLoaderGate from '@components/AppLoaderGate';
import TimezoneCapture from '@components/TimezoneCapture';
import MobileDeviceModal from '@components/MobileDeviceModal/MobileDeviceModal';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from './libs/queryClient';

// Preload main route so it's ready when auth completes (avoids Suspense fallback flicker)
const preloadHome = () => import('@pages/Home');

const App = () => {
  useEffect(() => {
    preloadHome();
  }, []);

  return (
    <AppLoaderGate>
      <MobileDeviceModal />
      {/* Facebook SDK loaded globally for Meta OAuth across the app */}
      <FacebookSDKLoader appId={META_APP_ID} />
      <QueryClientProvider client={queryClient}>
        <ConfigProvider theme={AntTheme()} wave={{ disabled: true }}>
          <OidcAuthProvider {...cognitoOidcConfig}>
            <FederatedSignInProviderFallback>
              <AuthProvider>
                <BrandingProvider>
                  <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
                    <TimezoneCapture />
                    <AppRoutes />
                  </GoogleOAuthProvider>
                </BrandingProvider>
              </AuthProvider>
            </FederatedSignInProviderFallback>
          </OidcAuthProvider>
        </ConfigProvider>
      </QueryClientProvider>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={true}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      {APP_ENV === 'production' && <HubspotScript />}
    </AppLoaderGate>
  );
};

export default App;
